// Define all application route paths as constants
export const ROUTES = {
  CREATE: '/create',
  LIBRARY: '/library',
  STORY: '/story', // Used as base path; actual route has storyId parameter
};
